import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {contentFeedsApi} from '../../../contentFeeds.api';
import {RemoteAiContentGenerationSetup} from 'common/src/modules/contentFeeds/contentFeeds.aiContentTypes';
import {setFeed} from '../reducers/contentFeedPageBase.slice';

export const updateColumnGenerationSetup = createAsyncThunk(
  `${BreadcrumbName.ContentFeedPage}/updateColumnGenerationSetup`,
  async (
    {feedId, request}: {feedId: number; request: {columnKey: string; generationSetup: RemoteAiContentGenerationSetup}},
    {dispatch},
  ) => {
    await contentFeedsApi.updateColumnGenerationSetup(feedId, request);
    const feed = await contentFeedsApi.getFeed(feedId);
    dispatch(setFeed(feed));
  },
);
